import { combineReducers } from 'redux';
import appReducer from './slice/appSlice';
import authReducer from './slice/authSlice';

const rootReducer = combineReducers({
    authReducer,
    appReducer,
});

export default rootReducer;
